import React from 'react';
import DatePicker from 'react-datepicker';
import { Field, ErrorMessage, useFormikContext } from 'formik';
import "react-datepicker/dist/react-datepicker.css";
import { FormGroup, Row } from 'react-bootstrap';

// Add style override for react-datepicker time color
const datepickerTimeStyle = `
.react-datepicker__time-list-item, .react-datepicker__time-list-item--selected {
  color: #000 !important;
}
`;

const DatePickerInput = ({ label, name, ...rest }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <>
      {/* Inject style for time color override */}
      <style>{datepickerTimeStyle}</style>
      <Row>
        <FormGroup controlId={name}>
          <p className="mb-1 text-dark">{label}</p>
          <Field name={name}>
            {({ field }) => (
              <DatePicker
                {...field}
                id={name}
                selected={(field.value && new Date(field.value)) || null}
                onChange={(val) => setFieldValue(name, val)}
                {...rest}
                className='form-control'
              />
            )}
          </Field>
          <ErrorMessage name={name} component="div" className="error-message text-danger" />
        </FormGroup>
      </Row>
    </>
  );
};

export default DatePickerInput;
